export default {
  helpText: 'Select and order the columns to show in the Parts overview table. This setting applies globally to all users.',
  selectedColumns: 'Selected columns',
  nonSelectedColumns: 'Available columns',
};
